function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Mask");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.4527237,20.744065 C19.6379297,20.744065 24.0678077,23.5773885 26,28 L3,28 C4.99131912,23.7176615 9.37055956,20.744065 14.4527237,20.744065 Z M18.6513116,14.0790288 L22.0283276,14.913699 C20.3057199,17.1935538 17.5536888,18.6696585 14.4527237,18.6696585 C11.4149221,18.6696585 8.7119845,17.253075 6.98365872,15.052008 L10.2533116,14.2430288 L10.2537141,14.5580488 C10.2537141,15.0708846 10.6397543,15.4935559 11.137093,15.551321 L11.2537141,15.5580488 L17.6517333,15.5580488 C18.1645691,15.5580488 18.5872404,15.1720086 18.6450055,14.6746699 L18.6517333,14.5580488 L18.6513116,14.0790288 Z M5.06415442,10.3857107 L10.2533116,11.6670288 L10.2533116,12.6400288 L6.08368585,13.6705198 C5.55115266,12.6690825 5.19734529,11.5603495 5.06415442,10.3857107 Z M23.8203758,10.5560439 C23.6808416,11.6111867 23.3629687,12.6109219 22.8976282,13.5247474 L18.6513116,12.4750288 L18.6513116,11.8320288 L23.8203758,10.5560439 Z M14.4527237,0 C19.5348031,0 23.6796821,3.9646631 23.8919594,8.934396 L18.6463151,10.2301019 C18.5979888,9.76573502 18.2318757,9.39582498 17.7692676,9.34166348 L17.6517333,9.33482926 L11.2537141,9.33482926 C10.8339883,9.33482926 10.4746588,9.5934165 10.3263469,9.95996966 L10.2883345,10.073024 L5.02179616,8.77276581 C5.31594494,3.87897821 9.4258616,0 14.4527237,0 Z",
  id: "Combined-Shape",
  fill: "currentColor"
})));

var SvgMask = function SvgMask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mask.7b6fa9dd.svg";
export { ForwardRef as ReactComponent };